export default __webpack_public_path__ + "static/media/128x128.5a36e607.jpg";